import axios from 'axios';
import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay, A11y } from 'swiper';
import 'swiper/css/bundle';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import './Footer.css';
//import Slider from 'react-slick';
//import 'slick-carousel/slick/slick.css';
//import 'slick-carousel/slick/slick-theme.css';

import Modal from './Modal.js';
const BASE_URL = 'https://testwire.wockhardt.com';

const Employee_BASE_URL = 'https://e2api.wockhardt.com';
const jwt = localStorage.getItem('jwt'); // get the JWT token from local storage

function formatDate(dateString) {
  const parts = dateString.split(".");
  return `${parts[2]}-${parts[1]}-${parts[0]}`;
  //return `${parts[1]}/${parts[0]}/${parts[2]}`;
}

const handleLogout = () => {
  // Clear token from local storage
  localStorage.removeItem('jwt');
  // Redirect to login page
  window.location.href = '/login';
}

/*const settings = {
  dots: true, // Display navigation dots
  infinite: true, // Allow infinite scrolling
  speed: 500, // Animation speed in milliseconds
  slidesToShow: 3, // Number of slides to show at once
  slidesToScroll: 1, // Number of slides to scroll at a time
  responsive: [
    {
      breakpoint: 768, // Breakpoint for smaller screens
      settings: {
        slidesToShow: 1, // Adjust the number of slides to show for smaller screens
      }
    }
  ]
};*/


class E2dashboard extends React.Component 
{
  state = {show:false,showDiv: false, data1: null,data2:null,data3:null,data4:null,data5:null,data6:null,data7:null,data8:null, responseData: null,username: '',email: '',job: '',picture: '',pictureurl: '',empcode:''};

  fetchData0 = (userId) => 
  {
    axios.get(`${BASE_URL}/api/users/${userId}?populate=*`,{headers: {Authorization: `Bearer ${jwt}`,'Content-Type': 'application/json'},})
    .then(res => {this.setState({ data0: res.data });console.log('API response user', res);})
    .catch(error => {console.error('API ERROR:', error);});
  };


  fetchData1 = () => {
    axios.get(`${BASE_URL}/api/quick-links?populate=*`,{
      headers: {
          Authorization: `Bearer ${jwt}`,
          'Content-Type': 'application/json'
        },
  })
      .then(res => {
        this.setState({ data1: res.data });
      })
      .catch(error => {
        console.error('API error for about-user-learnings:', error);
      });
  };

  fetchData2 = () => {
    axios.get(`${BASE_URL}/api/brainwaves?populate=*`)
      .then(res => {
        this.setState({ data2: res.data });
      })
      .catch(error => {
        console.error('API error for brainwaves:', error);
      });
  };

  fetchData3 = () => {
    axios.get(`${BASE_URL}/api/event-wockhardts?populate=*`)
      .then(res => {
        this.setState({ data3: res.data });
      })
      .catch(error => {
        console.error('API error for event-wockhardts:', error);
      });
  };

  fetchData4 = () => {
    axios.get(`${BASE_URL}/api/power-lectures?populate=*`)
      .then(res => {
        this.setState({ data4: res.data });
      })
      .catch(error => {
        console.error('API error for power-lectures:', error);
      });
  };

  fetchData5 = () => {
    axios.get(`${BASE_URL}/api/leaders-talk-homes?populate=*`)
      .then(res => {
        this.setState({ data5: res.data });
      })
      .catch(error => {
        console.error('API error for power-lectures:', error);
      });
  };

  fetchData6 = () => {
    axios.get(`${BASE_URL}/api/latest-news-headlines?populate=*`)
      .then(res => {
        this.setState({ data6: res.data });
      })
      .catch(error => {
        console.error('API error for power-lectures:', error);
      });
  };

  fetchData7 = () => {
    axios.get(`${BASE_URL}/api/header-buttons?populate=*`)
      .then(res => {
        this.setState({ data7: res.data });
      })
      .catch(error => {
        console.error('API error for header-button:', error);
      });
  };
  
  fetchData8 = () => {
    axios.get(`${BASE_URL}/api/digital-transformations?populate=*`)
      .then(res => {
        //console.log('API response for digital-transformation-videos:', res);
        this.setState({ data8: res.data });
      })
      .catch(error => {
        console.error('API error for digital-transformation-videos:', error);
      });
  };

  fetchUserData = (userId) => {
    axios.get(`${BASE_URL}/api/users/${userId}?populate=*`)
      .then(res => {
        this.setState({ responseData: res.data });
        let id = res.data.id;
        let username = res.data.username;
        let email = res.data.email;
        let job = res.data.job;
        let empcode = res.data.empcode;
        let picture = res.data.picture.name;
        let pictureurl = res.data.picture.url;
        this.setState({ id });
        this.setState({ username });
        this.setState({ email });
        this.setState({ job });
        this.setState({ empcode });
        this.setState({ picture });
        this.setState({ pictureurl });

      })
      .catch(error => {
        console.error(`API error for user data with id ${userId}:`, error);
      });
  };

  componentDidMount() {
    this.fetchData1();
    this.fetchData2();
    this.fetchData3();
    this.fetchData4();
    this.fetchData5();
    this.fetchData6();
    this.fetchData7();
    this.fetchData8();
    let responseData = localStorage.getItem("responseData");
    this.setState({ responseData });
    let jwtDataParsed = JSON.parse(responseData);
    let id = jwtDataParsed.user.id;
    //console.log('id:', id);
    let username = jwtDataParsed.user.username;
    let email = jwtDataParsed.user.email;
    let job = jwtDataParsed.user.job;
    let empcode = jwtDataParsed.user.empcode;
    //console.log('empcode:', empcode);
    this.setState({ username });
    this.setState({ email });
    this.setState({ job });
    this.setState({ empcode });
    this.setState({ id });
    if (id) {
      this.fetchUserData(id);
      this.fetchData0(id);
      this.fetchEmployeeData(empcode);
    } else {
      console.error('id is undefined');
    }
    this.showModal();
  }

 showModal = () => {
    this.setState({ show: true });
  };

  hideModal = () => {
    this.setState({ show: false });
  };

  fetchEmployeeData = (empcode) => {
    axios.get(`${Employee_BASE_URL}/api/flutter/GetEmpDetails?empcode=${empcode}`)
      .then(res => {
        const employeeData = res.data[0];
        console.log('API Employees:', employeeData)
        this.setState({ employeeData: employeeData });
        let gender = employeeData.gender;
        let address = employeeData.address;
        let username = employeeData.empname;
        let positioN_CODE = employeeData.positioN_CODE;
        let position = employeeData.position;
        let empcode = employeeData.empcode;
        let area = employeeData.area;
        let subarea = employeeData.subarea;
        let subgroup = employeeData.subgroup;
        let doj = employeeData.doj;
        const inputDateString = employeeData.doj;
        const outputDateString = formatDate(inputDateString); // "11/16/1981"
        let dob = employeeData.dob;
        const inputDateStrings = employeeData.dob;
        const outputDateStrings = formatDate(inputDateStrings); // "11/16/1981"
        let companY_CODE = employeeData.companY_CODE;
        let cosT_CENTER = employeeData.cosT_CENTER;
        let worK_CNTRCT = employeeData.worK_CNTRCT;
        let organization = employeeData.organization;
        let communication = employeeData.communication;
        let flM_CODE = employeeData.flM_CODE;
        let reP_MGR = employeeData.reP_MGR;
        let refresH_DATE = employeeData.refresH_DATE;
        let peR_ADMIN = employeeData.peR_ADMIN;
        let paY_ADMIN = employeeData.paY_ADMIN;
        let f_NAME = employeeData.f_NAME;
        let l_NAME = employeeData.l_NAME;
        let orG_CODE = employeeData.orG_CODE;
        let country = employeeData.country;
        let jobrole = employeeData.jobrole;
        
        /* Added on17 June23 */
        let salutation = employeeData.salutation;
        let lastName = employeeData.lastName;
        let firstName = employeeData.firstName;
        let middleName = employeeData.middleName;
        let pan = employeeData.pan;
        let aadharNo = employeeData.aadharNo;
        let uan = employeeData.uan;
        let officialEmail = employeeData.officialEmail;
        let personalMobile = employeeData.personalMobile;
        let bankName = employeeData.bankName;
        let bankAccountNo = employeeData.bankAccountNo;
        let ifsc = employeeData.ifsc;
        let aadharName = employeeData.aadharName;
        let pfNo = employeeData.pfNo;
        let passportNo = employeeData.passportNo;
        let personalEmail = employeeData.personalEmail;
        let officeTelNo = employeeData.officeTelNo;
        let officeMobile = employeeData.officeMobile;
        let peR_ADMIN_EMAIL = res.data.peR_ADMIN_EMAIL;
        let peR_ADMIN_CODE = res.data.peR_ADMIN_CODE;
        let funC_HEAD_CODE = res.data.funC_HEAD_CODE;
        let funC_HEAD_EMAIL = res.data.funC_HEAD_EMAIL;
        /* Added on17 June23 End */

        /* Added this to pass userid in update api */
        let responseData = localStorage.getItem("responseData");
        this.setState({ responseData });
        let jwtDataParsed = JSON.parse(responseData);
        let userId = jwtDataParsed.user.id;
        //console.log('userId:', userId);
        /* Added this to pass userid in update api End */

        this.setState({ empcode });
        this.setState({ gender });
        this.setState({ address });
        this.setState({ username });
        console.log('usernamesss:', username);
        this.setState({ positioN_CODE });
        this.setState({ position });
        this.setState({ area });
        this.setState({ subarea });
        this.setState({ subgroup });
        this.setState({ doj: formatDate(employeeData.doj) });
        this.setState({ dob: formatDate(employeeData.dob) });
        this.setState({ companY_CODE });
        this.setState({ cosT_CENTER });
        this.setState({ worK_CNTRCT });
        this.setState({ organization });
        this.setState({ communication });
        this.setState({ flM_CODE });
        this.setState({ reP_MGR });
        this.setState({ refresH_DATE });
        this.setState({ peR_ADMIN });
        this.setState({ paY_ADMIN });
        this.setState({ f_NAME });
        this.setState({ l_NAME });
        this.setState({ orG_CODE });
        this.setState({ country });
        this.setState({ jobrole });
        
        
        /* Added on17 June23 */
        this.setState({ salutation });
        this.setState({ lastName });
        this.setState({ firstName });
        this.setState({ middleName });
        this.setState({ pan });
        this.setState({ aadharNo });
        this.setState({ uan });
        this.setState({ officialEmail });
        this.setState({ personalMobile });
        this.setState({ bankName });
        this.setState({ bankAccountNo });
        this.setState({ ifsc });
        this.setState({ aadharName });
        this.setState({ pfNo });
        this.setState({ passportNo });
        this.setState({ personalEmail });
        this.setState({ officeTelNo });
        this.setState({ officeMobile });
        this.setState({ peR_ADMIN_EMAIL });
        this.setState({ peR_ADMIN_CODE });
        this.setState({ funC_HEAD_CODE });
        this.setState({ funC_HEAD_EMAIL });
        /* Added on17 June23 End */


          /* Prepare the data to be sent to the Strapi API*/
          const strapiData = {
            empcode: employeeData.empcode,
            gender: employeeData.gender,
            address: employeeData.address,
            username: employeeData.empname,
            positioN_CODE: employeeData.positioN_CODE,
            position: employeeData.position,
            area: employeeData.area,
            subarea: employeeData.subarea,
            subgroup: employeeData.subgroup,
            doj: formatDate(employeeData.doj),
            dob: formatDate(employeeData.dob),
            companY_CODE: employeeData.companY_CODE,
            cosT_CENTER: employeeData.cosT_CENTER,
            worK_CNTRCT: employeeData.worK_CNTRCT,
            organization: employeeData.organization,
            communication: employeeData.communication,
            flM_CODE: employeeData.flM_CODE,
            reP_MGR: employeeData.reP_MGR,
            refresH_DATE: employeeData.refresH_DATE,
            peR_ADMIN: employeeData.peR_ADMIN,
            paY_ADMIN: employeeData.paY_ADMIN,
            f_NAME: employeeData.f_NAME,
            l_NAME: employeeData.l_NAME,
            orG_CODE: employeeData.orG_CODE,
            country: employeeData.country,
            jobrole: employeeData.jobrole,
            
            /* Added on17 June23 */
            salutation : employeeData.salutation,
            lastName : employeeData.lastName,
            firstName : employeeData.firstName,
            middleName : employeeData.middleName,
            pan : employeeData.pan,
            aadharNo : employeeData.aadharNo,
            uan : employeeData.uan,
            officialEmail : employeeData.officialEmail,
            personalMobile : employeeData.personalMobile,
            bankName : employeeData.bankName,
            bankAccountNo : employeeData.bankAccountNo,
            ifsc : employeeData.ifsc,
            aadharName : employeeData.aadharName,
            pfNo : employeeData.pfNo,
            passportNo : employeeData.passportNo,
            personalEmail : employeeData.personalEmail,
            officeTelNo : employeeData.officeTelNo,
            officeMobile : employeeData.officeMobile,
            peR_ADMIN_EMAIL : employeeData.peR_ADMIN_EMAIL,
            peR_ADMIN_CODE : employeeData.peR_ADMIN_CODE,
            funC_HEAD_CODE : employeeData.funC_HEAD_CODE,
            funC_HEAD_EMAIL : employeeData.funC_HEAD_EMAIL
            /* Added on17 June23 End */
          };
           //axios.put(`${BASE_URL}/api/users/4?empcode=${empcode}`, strapiData, {
            axios.put(`${BASE_URL}/api/users/${userId}?empcode=${empcode}`, strapiData, {
            headers: {
              'Content-Type': 'application/json'
            }
          })
          .then(res => {
            console.log('Data stored in Strapi:', res);
          })
          .catch(error => {
            console.error('Error storing data in Strapi:', error);
          });
      })
      .catch(error => {
        console.error('API error:', error);
      });
  };

  handleClick = () => {
    this.setState({
      showDiv: !this.state.showDiv
    });
  };

  handleGenerateQR = () => {
    const { userId} = this.state.data0;
console.log('Test')
    const payload = {data: this.state.data0};
	  console.log(JSON.stringify(payload));;
console.log('QR Data');
	  console.log(payload);
    axios.post('https://vcqr.wockhardt.com/api/v1/dostemp', payload,{
  headers: {
    'Accept': '*/*',
    'Content-Type': 'application/json',
     
  },})
      .then(response => {
        //console.log('QR generation response:', response);
        alert('Your request for eVisiting Card has been sent to Functional Head for Approval.');
      })
      .catch(error => {
        console.error('QR generation error:', error);
      });
  };
  

  /*logout = () => {
    fetch('${BASE_URL}api/auth/local/logout', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('jwt')}`
      },
    })
      .then(res => res.json())
      .then(response => {
        localStorage.removeItem('jwt');
        this.setState({
          isAuthenticated: false
        });
      })
      .catch(error => console.log(error));
  }*/
  

  render() 
  {
    if (this.state.data1 === null || this.state.data2 === null || this.state.data3 === null || this.state.data4 === null || this.state.data5 === null || this.state.data6 === null || this.state.data7 === null || this.state.data8 === null || this.state.responseData === null) 
    {
      return <div>Loading...</div>;
    }

    const profleImage = this.state.pictureurl && this.state.pictureurl !== "null"? `${BASE_URL}${this.state.picctureurl}`: "/uploads/demouser_5fca6451b6.png?updated_at=2023-06-23T05:11:32.879Z";

    return (
      <div className='bg-silver'>
        <div className='bg-white fixed top-0 right-0 left-0 z-20'>
          <div className="flex justify-between mb-2" > 
            <div className='mt-3 ml-5'>
              <a href='/'><img src="/Other_Images/e2logo.png" class="img-fluid w-[183px] h-[45px]" alt=""></img></a>
            </div>
            <div className='flex'>
                  <ul class="navbar-list">
                     <li>
                     <img style={{marginTop: 5,marginRight: 5,cursor: 'pointer',borderWidth: 2,borderColor: '#0f90c0'}} src={this.state.pictureurl ? `${BASE_URL}${this.state.pictureurl}` : 'https://testwire.wockhardt.com/uploads/demouser_5fca6451b6.png?updated_at=2023-06-23T05:11:32.879Z'} alt={this.state.pictureurl ? this.state.picture.alternativeText : 'Dummy Alt Text'} className="w-[50px] h-[50px] rounded-3xl search-toggle iq-waves-effect bg-primary text-white" onClick={this.handleClick}/>
  
                        {this.state.showDiv && (<div class="iq-sub-dropdown iq-user-dropdown" style={{width:'auto',right:'0', position:'absolute', background:'#ffffff', padding:0, borderRadius:'4px', boxShadow:'0px 0px 25px 0px rgba(45, 69, 95, 0.1)'}}>
                           <div class="iq-card shadow-none m-0" style={{background:'#ffffff', borderRadius:'4px',border:'none', margin:0, boxShadow:'none'}}>
                              <div class="iq-card-body p-0 " style={{padding:0}}>
                                 <div class="bg-primary p-3" style={{background:'#0f90c0'}}>
                                  <h5 class="mb-0 text-white text-xs line-height">Welcome, {/*{this.state.employeeData.username}*/} {this.state.username} </h5>
                                  <span class="text-white text-xs">{/*{this.state.employeeData.email}*/} {this.state.email}</span>
                                  <p class="text-white text-xs">Employee Code : {/*{this.state.employeeData.empcode}*/} {this.state.empcode}</p>
                                  {/*<p class="text-white text-xs">Position : {this.state.empcode} {this.state.employeeData.position}</p>*/}
                                 </div>

                                 <a href="/profile" class="iq-sub-card iq-bg-primary-hover" style={{fontSize:'inherit', padding:5, lineHeight:'normal', borderBottom:'1px solid #0f90c0', display:'inline-block', width:'100%'}}>
                                    <div class="media align-items-center">
                                       <div class="media-body ml-3" style={{marginLeft:'1rem'}}>
                                          <h6 class="mb-0 text-xs" style={{marginBottom:'0'}}>My Profile</h6>
                                          <p class="mb-0 text-xs" style={{marginBottom:'0'}}>View personal profile details.</p>
                                       </div>
                                    </div>
                                 </a>
                                 <div class="d-inline-block w-100 text-center p-3 text-xs" style={{textAlign:'center',width:'100%', display:'inline-block'}}>
                                    {/*<a class="iq-bg-danger iq-sign-btn" href="/login" role="button" style={{textAlign:'center', padding:'.375rem 1rem', borderRadius:'.25rem',border:'1px solid transparent', display:'inline-block', background:'#0f90c0', color:'#ffffff'}} >Sign out<i class="ri-login-box-line ml-2"></i></a>*/}
                                    <a className="iq-bg-danger iq-sign-btn" href="/generateevisitingcard" role="button" style={{textAlign:'center', padding:'.375rem 1rem', borderRadius:'.25rem',border:'1px solid transparent', float:'left', display:'inline-block', background:'#0f90c0', color:'#ffffff'}} >Generate eVisitingCard<i className="ri-login-box-line ml-2"></i></a>
                                    {/*<a className="iq-bg-danger iq-sign-btn" role="button" onClick={this.handleGenerateQR} style={{textAlign:'center', padding:'.375rem 1rem', borderRadius:'.25rem',border:'1px solid transparent', float:'left', display:'inline-block', background:'#0f90c0', color:'#ffffff'}} >Request eVisitingCard<i className="ri-login-box-line ml-2"></i></a>*/}
                                    <a className="iq-bg-danger iq-sign-btn" href="#" role="button" onClick={handleLogout} style={{textAlign:'center', padding:'.375rem 1rem', borderRadius:'.25rem',border:'1px solid transparent', float:'right', display:'inline-block', background:'#0f90c0', color:'#ffffff'}} >Sign out<i className="ri-login-box-line ml-2"></i></a>
                                 </div>
                              </div>
                           </div>
                        </div>
                      )}
                     </li>
                  </ul>
            </div>
          </div>
          <div  style={{ display: 'flex', justifyContent:'space-around' }} >  
            {this.state.data7.data.map(item => (
              <div  className="mb-1">
                <div className="col-md-4" key={item.id}>
                    <a href={item.attributes.Link}><button className='text-white bg-blue mr-3 lg:w-[390px] md:w-[240px] w-[105px] rounded-md ml-3 lg:p-3 p-1 text-xs lg:text-sm'>{item.attributes.Title}</button></a>
                </div>
             </div>
            ))}
          </div>
        </div> 

  <div className="bg-silver">
  
      <section>     
        <div className="">
        {/*{this.state.data6.data.map(item => (
            <div key={item.id}>
              <div className="mt-32 rounded-2xl bg-newsblue  p-3 mx-4 shadow-xl ">
                <a href='/latestnews'><p className="text-l mt-3 text-darkblue">{item.attributes.Title}</p>
                <p className="text-xs text-darkblue"> ({item.attributes.Location}, {item.attributes.Date}) </p></a>
                <a href={item.attributes.Link}><p className='text-red text-xs text-right'>Read More</p></a>
                {item.attributes.File && item.attributes.File.data && item.attributes.File.data.attributes && (<a className="" target="_blank" href={`${BASE_URL}${item.attributes.File.data.attributes.url}`}><p class="text-red text-xs text-right">View</p></a>)}
              </div>
            </div>
        ))}*/}
          
          <Swiper modules={[Pagination, Autoplay, A11y]} spaceBetween={10} slidesPerView={1} pagination={{ clickable: true }} autoplay={{ delay: 3000 }}>
            {this.state.data6.data.map((item) => (
              <SwiperSlide key={item.id}>
                <div className="mt-32 rounded-2xl bg-newsblue p-3 mx-4 shadow-xl">
                  <a href="/latestnews">
                    <p className="text-l mt-3 text-darkblue">{item.attributes.Title}</p>
                    <p className="text-xs text-darkblue">({item.attributes.Location}, {item.attributes.Date})</p>
                  </a>
                  <a href={item.attributes.Link}><p className="text-red text-xs text-right">Read More</p></a>
                  {item.attributes.File && item.attributes.File.data && item.attributes.File.data.attributes && ( <a className="" target="_blank" href={`${BASE_URL}${item.attributes.File.data.attributes.url}`}><p className="text-red text-xs text-right">View</p> </a>)} 
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <div className='lg:flex justify-between mx-4' style={{paddingTop:8}}>
            <div className='bg-white rounded-2xl p-4 my-4 lg:my-0 lg:w-[33%] h-[200px] shadow-xl'>
              <div className='flex justify-between'>
                <p className='font-semibold m-1 text-xs text-headings'>Power Lectures</p>
                <a href='/powerlectures'><p className='text-red text-xs'>View All</p></a>
              </div>
              <div className='lg:w-[100%] h-[1px] bg-green'></div>
              {this.state.data4.data.map(item => (
                <div key={item.id}>
                  <div className="flex">    
                    <div className='w-[200px] h-[110px] pt-6'>
                      {item.attributes.Icon && (<img class="w-[200px] h-[100px] rounded-2xl" src={`${BASE_URL}${item.attributes.Icon.data.attributes.url}`} alt={item.attributes.Icon.data.attributes.alternativeText} />)}
                    </div>  
                    <div className="mt-5 ml-5 text-sm">
                        {/*<p className='font-semibold text-headings'>{item.attributes.Title}</p>*/}
                        {/*<p className='mt-1'>{item.attributes.Date}</p> */}
                        {/*<li className='flex mt-2'>{item.attributes.Icon && (<img class="w-[15px] h-[15px]" src={`${BASE_URL}${item.attributes.Image.data.attributes.url}`} alt={item.attributes.Image.data.attributes.alternativeText} />)}<a style={{marginTop:'-4px'}} className="ml-4" target="_blank" href='{item.attributes.Link}'>Watch Now</a></li>   */}
                      <p className='text-xs'>{item.attributes.Date}</p>
                      <p className='font-semibold text-xs'>{item.attributes.Title}</p>
                      <li className='flex mt-2'>{item.attributes.Icon && (<img class="w-[15px] h-[15px]" src={`${BASE_URL}${item.attributes.Image.data.attributes.url}`} alt={item.attributes.Image.data.attributes.alternativeText} />)}<a className="ml-4 text-xs" target="_blank" href={item.attributes.Link}>Watch Now</a></li>  
                      {item.attributes.File && item.attributes.File.data && item.attributes.File.data.attributes && (<a className="" target="_blank" href={`${BASE_URL}${item.attributes.File.data.attributes.url}`}><p class="text-red text-xs text-right">View</p></a>)}    
                    </div> 
                  </div>
                </div>
              ))}     
            </div>

            <div className='bg-white rounded-2xl p-4 lg:w-[33%] h-[200px] shadow-xl sm :mt-4'>
              <div className='flex justify-between'>
                <p className='font-semibold m-1 text-xs text-headings'>Quick Links</p>
                <a href='/quicklinks'><p className='text-red text-xs'>View All</p></a>
              </div>
              <div className='lg:w-[100%] h-[1px] bg-green'></div> 
              <div className='text-sm'>
                {this.state.data1.data.map(item => ( 
                  <div key={item.id}>
                    <ul className='text-sm'>
                      {/*<li className="flex mt-2">
                        {item.attributes.Icon && (<img className="w-[15px] h-[15px]" src={`${BASE_URL}${item.attributes.Icon.data.attributes.url}`} alt={item.attributes.Icon.data.attributes.alternativeText} />)}
                        {item.attributes.Link && (<a className="ml-4 text-xs" target="_blank" href={`${item.attributes.Link}${ item.attributes.Link.includes("?empcode=")? this.state.empcode: item.attributes.Link.includes("?empno=")? this.state.empcode: item.attributes.Link.includes("?EmployeeCode=")? this.state.empcode: item.attributes.Link.includes("?EmployeeNo=")? this.state.empcode: ""}`}>{item.attributes.Title}</a>)}
                      </li>
                {item.attributes.File && item.attributes.File.data && item.attributes.File.data.attributes && (<a className="" target="_blank" href={`${BASE_URL}${item.attributes.File.data.attributes.url}`}><p className="text-red text-xs text-right">View</p></a>)}*/}

<li className="flex mt-2">
  {item.attributes.Icon && (
    <img
      className="w-[15px] h-[15px]"
      src={`${BASE_URL}${item.attributes.Icon.data.attributes.url}`}
      alt={item.attributes.Icon.data.attributes.alternativeText}
    />
  )}
  {item.attributes.Link && (
    <a
      className="ml-4 text-xs"
      target="_blank"
      href={`${item.attributes.Link}${ item.attributes.Link.includes("?empcode=")? this.state.empcode: item.attributes.Link.includes("?empno=")? this.state.empcode: item.attributes.Link.includes("?EmployeeCode=")? this.state.empcode: item.attributes.Link.includes("?EmployeeNo=")? this.state.empcode: ""}`}
    >
      {item.attributes.Title}
    </a>
  )}
  {!item.attributes.Link && item.attributes.File && item.attributes.File.data && item.attributes.File.data.attributes && (
    <a
      className="ml-4 text-xs"
      target="_blank"
      href={`${BASE_URL}${item.attributes.File.data.attributes.url}`}
    >
      {item.attributes.Title}
    </a>
  )}
  {!item.attributes.Link && !(item.attributes.File && item.attributes.File.data && item.attributes.File.data.attributes) && (
    <p className="ml-4 text-xs">{item.attributes.Title}</p>
  )}
</li>

                    </ul>  
                  </div>
                ))}   
              </div>  
            </div>

            <div className='bg-white rounded-2xl p-4 my-4 lg:my-0 lg:w-[33%] h-[200px] shadow-xl'>
              <div className='flex justify-between'>
                <p className='font-semibold m-1 text-xs text-headings'>Leader's Talk</p>
                <a href='/leaderstalk'><p className='text-red text-xs'>View All</p></a>
              </div>
              <div className='lg:w-[100%] h-[1px] bg-green'></div>
              {this.state.data5.data.map(item => (
                <div key={item.id}>
                  <div className="flex">    
                    <div className='w-[200px] h-[110px] pt-6'>
                      {item.attributes.Image && (<img class="w-[200px] h-[100px] rounded-2xl" src={`${BASE_URL}${item.attributes.Image.data.attributes.url}`} alt={item.attributes.Image.data.attributes.alternativeText} />)}
                    </div>  
                    <div className="mt-5 ml-5 text-sm">
                        {/*<p className='font-semibold text-headings'>{item.attributes.Title}</p>*/}
                        {/*<p className='mt-1'>{item.attributes.Message}</p> */}
                        {/*<li className='flex mt-2'>{item.attributes.Icon && (<img class="w-[15px] h-[15px]" src={`${BASE_URL}${item.attributes.Icon.data.attributes.url}`} alt={item.attributes.Icon.data.attributes.alternativeText} />)}<a style={{marginTop:'-4px'}} className="ml-4" target="_blank" href='{item.attributes.Link}'>Watch Now</a></li>   */}
                      <p className='font-semibold text-xs text-headings'>{item.attributes.Title}</p>
                      <p className='text-xs'>{item.attributes.Message}</p>
                      <li className='flex mt-2'>{item.attributes.Icon && (<img class="w-[15px] h-[15px]" src={`${BASE_URL}${item.attributes.Icon.data.attributes.url}`} alt={item.attributes.Icon.data.attributes.alternativeText} />)}<a className="ml-4 text-xs" target="_blank" href={item.attributes.Link}>Watch Now</a></li>  
                      {item.attributes.File && item.attributes.File.data && item.attributes.File.data.attributes && (<a className="" target="_blank" href={`${BASE_URL}${item.attributes.File.data.attributes.url}`}><p class="text-red text-xs text-right">View</p></a>)}    
                    </div> 
                  </div>  
                </div>
              ))}     
            </div>
          </div>
        </div>
        </section>

       {/*<p className='text-xs' style={{marginBottom:'20'}}>Employee Code: {this.state.employeeData.empcode},Gender: {this.state.employeeData.gender},Address: {this.state.employeeData.address},Employee Name: {this.state.employeeData.empname},Position Code: {this.state.employeeData.positioN_CODE},Position: {this.state.employeeData.position},Area: {this.state.employeeData.area},Sub Area: {this.state.employeeData.subarea},Sub Group: {this.state.employeeData.subgroup},Date of Joining: {this.state.employeeData.doj},Date of Birth: {this.state.employeeData.dob},Company Code: {this.state.employeeData.companY_CODE},Cost Center: {this.state.employeeData.cosT_CENTER},Work Contract: {this.state.employeeData.worK_CNTRCT},Organization: {this.state.employeeData.organization},Communication: {this.state.employeeData.communication},Flm Code: {this.state.employeeData.flM_CODE},Rep Manager: {this.state.employeeData.reP_MGR},Refresh Date: {this.state.employeeData.refresH_DATE},Per Admin: {this.state.employeeData.peR_ADMIN},Pay Admin: {this.state.employeeData.paY_ADMIN},First Name: {this.state.employeeData.f_NAME},Last Name: {this.state.employeeData.l_NAME}, Organization Code: {this.state.employeeData.orG_CODE}</p>*/}
       {/*<p className='text-xs' style={{marginBottom:'20'}}>Employee Code: {employeeData.empcode},Gender: {employeeData.gender},Address: {employeeData.address},Employee Name: {employeeData.empname},Position Code: {employeeData.positioN_CODE},Position: {employeeData.position},Area: {employeeData.area},Sub Area: {employeeData.subarea},Sub Group: {employeeData.subgroup},Date of Joining: {employeeData.doj},Date of Birth: {employeeData.dob},Company Code: {employeeData.companY_CODE},Cost Center: {employeeData.cosT_CENTER},Work Contract: {employeeData.worK_CNTRCT},Organization: {employeeData.organization},Communication: {employeeData.communication},Flm Code: {employeeData.flM_CODE},Rep Manager: {employeeData.reP_MGR},Refresh Date: {employeeData.refresH_DATE},Per Admin: {employeeData.peR_ADMIN},Pay Admin: {employeeData.paY_ADMIN},First Name: {employeeData.f_NAME},Last Name: {employeeData.l_NAME}, Organization Code: {employeeData.orG_CODE}</p>*/}


        <section>
          <div className="">
            <div className="lg:flex justify-between mx-4 lg:pt-2"> 
              <div className='bg-white rounded-2xl p-4 my-4 lg:my-0 lg:w-[33%] h-[200px] shadow-xl'>
                <div className='flex justify-between'>
                  <p className='font-semibold m-1 text-xs text-headings'>Event@Wockhardt</p>
                </div>
                <div className='lg:w-[100%] h-[1px] bg-green'></div> 
                <div className='text-sm'>
                  {this.state.data3.data.map(item => ( 
                    <div key={item.id}>
                      <ul className='text-sm'>
                        {/*<li className='flex mt-2'>{item.attributes.Icon && (<img class="w-[15px] h-[15px]" src={`${BASE_URL}${item.attributes.Icon.data.attributes.url}`} alt={item.attributes.Icon.data.attributes.alternativeText} />)}<a className="ml-4" style={{marginTop:'-5px'}} target="_blank" href={item.attributes.Link}>{item.attributes.Title}</a></li>*/}
                        <li className='flex mt-2'>
                          {/*{item.attributes.Icon && (<img class="w-[15px] h-[15px]" src={`${BASE_URL}${item.attributes.Icon.data.attributes.url}`} alt={item.attributes.Icon.data.attributes.alternativeText} />)}<a className="ml-4 text-xs" target="_blank" href={item.attributes.Link}>{item.attributes.Title}</a></li>  
                        {item.attributes.File && item.attributes.File.data && item.attributes.File.data.attributes && (<a className="" target="_blank" href={`${BASE_URL}${item.attributes.File.data.attributes.url}`}><p class="text-red text-xs text-right">View</p></a>)}  */}
                        {item.attributes.Icon && (<img class="w-[15px] h-[15px]" src={`${BASE_URL}${item.attributes.Icon.data.attributes.url}`} alt={item.attributes.Icon.data.attributes.alternativeText} />)}
                        {item.attributes.Link ? (<a className="ml-4 text-xs" href={item.attributes.Link}>{item.attributes.Title}</a>) : (item.attributes.File && item.attributes.File.data && item.attributes.File.data.attributes ? (<a className="ml-4 text-xs" target="_blank" href={`${BASE_URL}${item.attributes.File.data.attributes.url}`}>{item.attributes.Title}</a>) : (<p className="ml-4 text-xs">{item.attributes.Title}</p>))}
                        </li>  
                      </ul>  
                    </div>
                  ))}   
                </div>  
              </div>

    
              
              <div className='bg-white rounded-2xl p-4 lg:w-[33%] h-[200px] shadow-xl sm :mt-4'>
              <div className='flex justify-between'>
                <p className='font-semibold m-1 text-xs text-headings'>Digital Transformation</p>
              </div>
              <div className='lg:w-[100%] h-[1px] bg-green'></div> 
              <div className='text-sm'>
                {this.state.data8.data.map(item => ( 
                    <div key={item.id}>
                      <ul className='text-sm'>
                        {/*<li className='flex mt-2'>{item.attributes.Icon && (<img class="w-[15px] h-[15px]" src={`${BASE_URL}${item.attributes.Icon.data.attributes.url}`} alt={item.attributes.Icon.data.attributes.alternativeText} />)}<a style={{marginTop:'-5px'}} className="ml-4" href={item.attributes.Link}>{item.attributes.Title}</a></li>*/}
                        <li className='flex mt-2'>{item.attributes.Icon && (<img class="w-[15px] h-[15px]" src={`${BASE_URL}${item.attributes.Icon.data.attributes.url}`} alt={item.attributes.Icon.data.attributes.alternativeText} />)}<a className="ml-4 text-xs" target="_blank" href={item.attributes.Link}>{item.attributes.Title}</a></li>  
                      </ul>  
                    </div>
                  ))}   
              </div>  
            </div>
            
            
            <div className='bg-white rounded-2xl p-4 lg:w-[33%] h-[200px] shadow-xl sm :mt-4'>
                <div className='flex justify-between'>
                  <p className='font-semibold m-1 text-xs text-headings'>Brainwave</p>
                </div>
                <div className='lg:w-[100%] h-[1px] bg-green'></div>
                {this.state.data2.data.map(item => (
                  <div key={item.id}>
                    <div className="flex">     
                      {/*<div className="mt-5 ml-5 text-sm">*/}
                      <div className="mt-5 ml-2 text-sm">
                        {/*<p className='font-semibold text-headings'>{item.attributes.Title}</p>*/}
                        {/*<p className='mt-1'>{item.attributes.Detail}</p> */}
                        <p className='font-semibold text-xs text-headings'>{item.attributes.Title}</p>
                        <p className='text-xs'>{item.attributes.Detail}</p>
                        <p className='text-red mt-1 text-xs '>{item.attributes.Link && (<a className="text-xs"target="_blank" href={`${item.attributes.Link}${item.attributes.Link.includes("?emailid=")? this.state.email: item.attributes.Link.includes("?EmailID=")? this.state.email: ""}`}>Know More</a>)}</p>
                        {item.attributes.File && item.attributes.File.data && item.attributes.File.data.attributes && (<a className="" target="_blank" href={`${BASE_URL}${item.attributes.File.data.attributes.url}`}><p class="text-red text-xs text-right">View</p></a>)}    
                        
                        
                        
                      </div> 
                    </div>  
                  </div>
                ))}     
              </div>
              
            </div>
          </div>
        </section>

  


        {/*<section>
          <div className=" bg-darkblue left-[0] bottom-[0] right-[0] ">
            <div className=' text-metal lg:flex lg:justify-between lg:mx-2 lg:pl-3 mx-2 '>
              <div className=''/>
              <div>
                <h3 className='my-3 lg:mt-1 ml-2 md:pl-3 text-white'>Copyright 2022 Wockhardt All Rights Reserved.</h3>
              </div>
            </div>
          </div>
        </section>*/}

        {/*<Modal show={this.state.show} handleClose={this.hideModal}></Modal>
        <button type="button" onClick={this.showModal}>Open</button>*/}
         {/*<Modal show={this.state.show} handleClose={this.hideModal}></Modal>*/} {/* Commented on 10 April 23 */}
        <section>
          <div className="footer">
            <h3 className='my-3 lg:mt-1 ml-2 md:pl-3 pr-3 text-xs text-darkblue'>Copyright 2022 Wockhardt All Rights Reserved.</h3>
          </div>
        </section>
  </div>
    </div>
  );
  }
};
  

export default E2dashboard;

